<template>
  <div class="chat-input">
    <a-button v-if="!loading && !init" class="refresh-button" icon="redo" @click="handleRefresh">
      答案不满意?再问一次
    </a-button>
    <a-button v-if="loading && !init" class="refresh-button" icon="stop" @click="handleStop">
      停止
    </a-button>
    <div class="content" ref="content">
      <a-row type="flex" justify="center" align="bottom">
        <a-col :span="22">
          <textarea 
          placeholder="请输入要询问的内容(推荐英文), 使用SHIFT+ENTER换行"
          class="input"
          ref="input"
          v-model="input"
          @keydown.enter="handleSubmit($event)"
          />
        </a-col>
        <a-col :span="2">
          <a-button class="button" :icon="loading?'loading':'mail'" size="large" @click="handleSubmitButton()"></a-button>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Input } from 'ant-design-vue'

Vue.use(Input)

export default {
  name: 'ChatInput',
  props: {
    collapsed: Boolean,
    loading: Boolean,
    init: Boolean
  },
  data() {
    return {
      input: ''
    }
  },
  watch:{
    collapsed(val) {
      if (val) {
        let textArea = this.$refs['content']
        textArea.style.left = '0px';
      } else {
        let textArea = this.$refs['content']
        textArea.style.left = '240px';
      }
    }
  },
  methods: {
    handleSubmit(event) {
      if (!event.shiftKey) {
        event.preventDefault()
        if (this.input && !this.loading) {
          this.$emit('emitSubmit',this.input)
          this.input = ''
          let textArea = this.$refs['input']
          let textAreaDiv = this.$refs['content']
          textArea.style.height = '32px';
          textAreaDiv.style.height = '48px';
        }
      }
    },
    handleSubmitButton() {
      if (this.input && !this.loading) {
        this.$emit('emitSubmit',this.input)
        this.input = ''
        let textArea = this.$refs['input']
        let textAreaDiv = this.$refs['content']
        textArea.style.height = '32px';
        textAreaDiv.style.height = '48px';
      }
    },
    handleRefresh() {
      this.$emit('emitRefresh')
    },
    handleStop() {
      this.$emit('emitStop')
    }
  },
  mounted() {
    let textArea = this.$refs['input']
    let textAreaDiv = this.$refs['content']
    textArea.addEventListener('input', (e) => {
        textArea.style.height = '32px';
        textArea.style.height = (e.target.scrollHeight) + 'px';
        textAreaDiv.style.height = '48px';
        textAreaDiv.style.height = (e.target.scrollHeight + 16) + 'px';
    });
  }
}
</script>

<style scoped>
.chat-input {
  position: fixed;
  bottom: 20px;
  left: 240px;
  right: 0;
}

.refresh-button{
  height: 35px;
  margin: auto;
  margin-bottom: 20px;
  color: black;
}

.content {
  margin: auto;
  height: 48px;
  min-height: 48px;
  width: 60%;
  min-width: 500px;
  background: #FFFFFF;
  border:1px solid rgba(0, 0, 0, 0.6);
  box-shadow: 0 0 5px 1px #999;
  border-radius: 4px;
  padding: 8px 4px 0px 10px;
}

textarea::-webkit-input-placeholder{
  color:rgb(160, 160, 160);
  text-shadow: none;
  -webkit-text-fill-color: initial;
}

.button {
  vertical-align:middle;
  height: 30px;
  margin-bottom: 8px;
  font-size: 20px;
}

.input {
  width: 100%;
  font-size: 16px;
  resize: none;
  height: 32px;
  min-height: 32px;
  overflow-wrap: break-word;
  border:none;
  outline: none;
  text-shadow: 0px 0px 0px #000;
  -webkit-text-fill-color: transparent;
}

</style>
